export default __webpack_public_path__ + "static/media/IMG_7051.66e11499.jpeg";